// Runtime URL rewrite to avoid requests to unavailable local hosts.
// No host file changes or external utilities required.
// Enabled ONLY when running locally.

import { environment } from './environments/environment';

const isLocal = (() => {
  try {
    const host = window.location.hostname || '';
    return environment?.NAME === 'local' || host === 'localhost' || host.endsWith('.localhost');
  } catch {
    return false;
  }
})();

if (isLocal) {
  const HOST_REWRITE_MAP: Record<string, string> = {
    // Map failing local host to real DEV host
    'login-dev-ra.localhost': 'login-dev-ra.www-dev.servicebox.com'
  };

  function rewriteUrl(input: string): string {
    try {
      const url = new URL(input, window.location.href);
      const replacement = HOST_REWRITE_MAP[url.hostname];
      if (replacement) {
        url.hostname = replacement;
        return url.toString();
      }
    } catch {
      // Non-URL strings (e.g., relative paths) are left untouched
    }
    return input;
  }

  // Patch fetch
  const originalFetch = window.fetch.bind(window);
  window.fetch = function(input: RequestInfo | URL, init?: RequestInit) {
    try {
      if (typeof input === 'string') {
        return originalFetch(rewriteUrl(input), init);
      }
      if (input instanceof URL) {
        return originalFetch(new URL(rewriteUrl(input.toString())), init);
      }
      if (input instanceof Request) {
        const newUrl = rewriteUrl(input.url);
        if (newUrl !== input.url) {
          // Preserve method/headers/body via cloning
          const cloned = new Request(newUrl, input);
          return originalFetch(cloned, init);
        }
      }
    } catch {
      // Fall through to original fetch on any error
    }
    return originalFetch(input as any, init);
  };

  // Patch XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(
    method: string,
    url: string,
    async?: boolean,
    user?: string | null,
    password?: string | null
  ) {
    try {
      const rewritten = rewriteUrl(url);
      return originalOpen.call(this, method, rewritten, async ?? true, user ?? null, password ?? null);
    } catch {
      return originalOpen.call(this, method, url, async ?? true, user ?? null, password ?? null);
    }
  };
}
